export default __webpack_public_path__ + "static/media/about.34d10282.jpg";